import React, {useContext, useEffect, useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import axios from 'axios';
import {dataScienceURL} from '../config';
import {styled} from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import {DialogTitleProps} from '../SideMenu/SideMenu';
import {authContext} from '../Context/Authentication/authContext';

const TITLE_MAPPINGS = {
  'Home sales': 'homesales',
  'Days on market': 'daysonmarket',
  'Price': 'ppsf',
  'MSP': 'msp'
}


const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    borderBottom: '1px solid #f7b047',
    borderTop: '1px solid #f7b047',
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogTitle-root': {
    color: '#f7b047',
    padding: '10px'
  },
  '& .MuiSvgIcon-root': {
    color: '#f7b047'
  },
  '& .MuiButton-root': {
    color: '#f7b047'
  },
  '& .MuiDialog-paper': {
    maxWidth: '50%'
  }
}));


const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const {children, onClose, ...other} = props;

  return (
    <DialogTitle sx={{m: 0, p: 2}} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon/>
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}


const PredictionsPopUp = (props: any) => {
  const {item, date, open, showInterval} = props
  const {state}: any = useContext(authContext)
  const [isOpen, setOpen] = useState(false);
  const [city, setCity] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [featuresData, setFeaturesData]: any = useState([]);

  useEffect(() => {
    let cityName: any = item.split(/ Mean| Low| High/);
    cityName = (cityName.length > 1) ? cityName[0] : '';
    if (!cityName) cityName = item

    if (cityName.split('_').length > 1) {
      cityName = cityName.split('_')[1]
    }
    setCity(cityName)
    setSelectedDate(date)
    setOpen(open)
  })


  const getPredictionInfo = async (cityName: any) => {
    if (cityName) {
      // @ts-ignore
      const type = TITLE_MAPPINGS[state?.selectedTab.trim()]
      const response = await axios.get(`${dataScienceURL}getImportantFeatures?state=${state.filters.state}&city=${cityName}&type=${type}&date=${selectedDate}&limit=5`);
      const features = response.data?.cube
      if (features.length) {
        setFeaturesData(features)
      } else {
        setFeaturesData([])
      }
    } else {
      setFeaturesData([])
    }
  }

  useEffect(() => {
    getPredictionInfo(city)
  }, [city]);


  const handleCloseDialog = () => {
    setOpen(false);
    setCity('');
    setSelectedDate('');
    props.closePopUp()
  };


  return (
    <>
      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={isOpen && featuresData.length}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleCloseDialog}>
          {city} Prediction Features
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <div className='feature-prediction'>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className='table-header'>Feature</TableCell>
                    <TableCell className='table-header'>Input Value</TableCell>
                    <TableCell className='table-header'>Importance</TableCell>
                    <TableCell className='table-header'>Growth</TableCell>
                    <TableCell className='table-header'>Explanation</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {featuresData.map((feature: any) => (
                    <TableRow hover key={feature.feature}>
                      <TableCell>{feature.feature}</TableCell>
                      <TableCell>{feature.inputValue}</TableCell>
                      <TableCell>{feature.importance}</TableCell>
                      <TableCell>{feature.growth}</TableCell>
                      <TableCell>{feature.explanation}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default PredictionsPopUp;